import FileSize from "../../../../components/commonComponent/FileSize";
import React, { useState } from "react";
import { PdfPreviewModal } from "../../../rightToInformation/components/RtiContent/PdfDocumentTable";
import cftiTamilNaduPdf from "../../../../assets/tenders/resource/ksr_project/CFTI_1_Tamilnadupdf-66c1c905621de9c331d877f549a4d0df.pdf";
import thiruvallurPdf from "../../../../assets/tenders/resource/ksr_project/Thruvallur2pdf-29ac595318d5e919ac43ea7537864a51.pdf";
import manavVikashRajasthanPdf from "../../../../assets/tenders/resource/ksr_project/Manav_Vikash_Rajsthan3pdf-7bae8eb64e507e92e321d32f30d9431d.pdf";
import jaiBhairavRajasthanPdf from "../../../../assets/tenders/resource/ksr_project/Jai_Bharav_Rajsthan4pdf-5b771f074884080274d28e4e930d4528.pdf";
import aisectAhmedabadPdf from "../../../../assets/tenders/resource/ksr_project/AISECT_Ahamadab5pdf-87fb73f8e9a38699ad282262dff8684d.pdf";
import nsicRajpuraPdf from "../../../../assets/tenders/resource/ksr_project/NSIC_RAJPURA6PDF-e033fc8ee898db7899470454df37ccbb.pdf";

const PdfBadge = () => (
  <span className="relative inline-block h-5 w-4 shrink-0 rounded-[2px] bg-[#dfe5ea] shadow-[0_1px_2px_rgba(0,0,0,0.16)]">
    <span className="absolute right-0 top-0 h-0 w-0 border-b-[6px] border-l-[6px] border-b-[#c7d0d8] border-l-transparent" />
    <span className="absolute left-1/2 top-[9px] -translate-x-1/2 rounded-[1px] bg-[#ff5145] px-[2px] py-[1px] text-[6px] font-bold leading-none text-white">
      PDF
    </span>
  </span>
);

const beneficiaryDocuments = {
  cftiTamilNadu: {
    title: "CFTI Tamil Nadu - List of Beneficiary",
    fileName: "CFTI_1_Tamilnadupdf-66c1c905621de9c331d877f549a4d0df.pdf",
    href: cftiTamilNaduPdf,
  },
  thiruvallur: {
    title: "Thiruvallur - List of Beneficiary",
    fileName: "Thruvallur2pdf-29ac595318d5e919ac43ea7537864a51.pdf",
    href: thiruvallurPdf,
  },
  manavVikashRajasthan: {
    title: "Manav Vikas Sanstha Jaipur - List of Beneficiary",
    fileName: "Manav_Vikash_Rajsthan3pdf-7bae8eb64e507e92e321d32f30d9431d.pdf",
    href: manavVikashRajasthanPdf,
  },
  jaiBhairavRajasthan: {
    title: "Jai Bhairav Welfare Society Bikaner - List of Beneficiary",
    fileName: "Jai_Bharav_Rajsthan4pdf-5b771f074884080274d28e4e930d4528.pdf",
    href: jaiBhairavRajasthanPdf,
  },
  aisectAhmedabad: {
    title: "AISECT Ahmedabad - List of Beneficiary",
    fileName: "AISECT_Ahamadab5pdf-87fb73f8e9a38699ad282262dff8684d.pdf",
    href: aisectAhmedabadPdf,
  },
  nsicRajpura: {
    title: "NSIC Rajpura - List of Beneficiary",
    fileName: "NSIC_RAJPURA6PDF-e033fc8ee898db7899470454df37ccbb.pdf",
    href: nsicRajpuraPdf,
  },
};

const kskProjectRows = [
  {
    state: { value: "Tamil Nadu", span: 9 },
    sca: {
      value: "Tamil Nadu Minorities Economic Development Corporation (TAMCO)",
      span: 9,
    },
    pia: { value: "CFTI, Chennai", span: 9 },
    sanctionedDate: { value: "19-02-2019", span: 9 },
    sanctionedAmount: { value: "13,21,680", span: 9 },
    district: { value: "Ambur", span: 2 },
    trade: "Stitcher (Goods & Garments)",
    candidates: "20",
    duration: "200",
    beneficiary: beneficiaryDocuments.cftiTamilNadu,
  },
  {
    trade: "Pre-Assembly Operator (Footwear)",
    candidates: "20",
    duration: "200",
  },
  {
    district: { value: "Vaniyambadi", span: 2 },
    trade: "Stitcher (Goods & Garments)",
    candidates: "20",
    duration: "200",
  },
  {
    trade: "Pre-Assembly Operator (Footwear)",
    candidates: "20",
    duration: "200",
  },
  {
    district: { value: "Walajabath", span: 2 },
    trade: "Stitcher (Goods & Garments)",
    candidates: "20",
    duration: "200",
  },
  {
    trade: "Pre-Assembly Operator (Footwear)",
    candidates: "20",
    duration: "200",
  },
  {
    district: { value: "Cuddalore" },
    trade: "Hand Embroiderer",
    candidates: "50",
    duration: "200",
  },
  {
    district: { value: "Krishnagiri" },
    trade: "Hand Embroiderer",
    candidates: "50",
    duration: "200",
  },
  {
    district: { value: "Thiruvallur" },
    trade: "Hand Embroiderer",
    candidates: "50",
    duration: "200",
    beneficiary: beneficiaryDocuments.thiruvallur,
  },
  {
    state: { value: "Rajasthan", span: 2 },
    sca: {
      value: "Rajasthan Minorities Finance and Development Corp. (RMFDC)",
      span: 2,
    },
    pia: { value: "Manav Vikas Sanstha, Jaipur" },
    sanctionedDate: { value: "06-08-2019" },
    sanctionedAmount: { value: "19,05,000" },
    district: { value: "Jaipur" },
    trade: "Sewing Machine Operator",
    candidates: "120",
    duration: "250",
    beneficiary: beneficiaryDocuments.manavVikashRajasthan,
  },
  {
    pia: { value: "Jai Bhairav Welfare Society, Bikaner" },
    sanctionedDate: { value: "29-01-2020" },
    sanctionedAmount: { value: "7,88,400" },
    district: { value: "Bikaner" },
    trade: "Hand Embroiderer",
    candidates: "60",
    duration: "200",
    beneficiary: beneficiaryDocuments.jaiBhairavRajasthan,
  },
  {
    state: { value: "Gujarat", span: 2 },
    sca: {
      value: "Gujarat Minorities Finance and Development Corporation (GMFDC)",
      span: 2,
    },
    pia: { value: "AISECT, Ahmedabad", span: 2 },
    sanctionedDate: { value: "02-01-2020", span: 2 },
    sanctionedAmount: { value: "16,80,000", span: 2 },
    district: { value: "Vadodara" },
    trade: "Beauty and wellness (Pedicurist & Manicurist)",
    candidates: "60",
    duration: "250",
    beneficiary: beneficiaryDocuments.aisectAhmedabad,
  },
  {
    district: { value: "Godhra" },
    trade: "Beauty and wellness (Pedicurist & Manicurist)",
    candidates: "30",
    duration: "250",
  },
  {
    state: { value: "Punjab", span: 3 },
    sca: {
      value:
        "Punjab State Backward Classes Land Development & Finance Corporation (BACKFINCO)",
      span: 3,
    },
    pia: { value: "NSIC Rajpura", span: 3 },
    sanctionedDate: { value: "01-03-2021", span: 3 },
    sanctionedAmount: { value: "18,97,800", span: 3 },
    district: { value: "Rajpura", span: 3 },
    trade: "Assistant Beauty Therapist",
    candidates: "90",
    duration: "250",
    beneficiary: beneficiaryDocuments.nsicRajpura,
  },
  {
    trade: "Customer Care Executive",
    candidates: "30",
    duration: "200",
  },
  {
    trade: "Retail Store Executive",
    candidates: "30",
    duration: "180",
  },
];

const headers = [
  "State",
  "SCA",
  "PIA",
  "Sanctioned Date",
  "Sanctioned Amount in Rs.",
  "District",
  "Trade",
  "Candidates",
  "Duration in Hrs.",
  "List of Beneficiary",
];

const GroupedCell = ({ cell, className = "" }) => {
  if (!cell) {
    return null;
  }

  return (
    <td
      rowSpan={cell.span || 1}
      className={`border border-[#b8d2ff] px-2 py-3 text-center align-top text-[13px] font-medium leading-[1.25] text-[#123764] ${className}`}
    >
      {cell.value}
    </td>
  );
};

const BeneficiaryCell = ({ document, onOpen }) => (
  <td className="border border-[#b8d2ff] px-2 py-3 text-center align-middle text-[13px] font-medium text-[#123764]">
    {document ? (
      <button
        type="button"
        onClick={() => onOpen(document)}
        title={document.fileName}
        className="mx-auto inline-flex items-center gap-1.5 rounded-[3px] text-[#16376c] underline underline-offset-2 transition-colors hover:text-[#0f8a7e] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#0f8a7e] focus-visible:ring-offset-2"
      >
        <span>Open</span>
        <PdfBadge /><FileSize href={document.href} fileName={document.fileName} />


      </button>
    ) : (
      "-"
    )}
  </td>
);

const KskProjectDetails = () => {
  const [selectedDocument, setSelectedDocument] = useState(null);

  return (
    <section className="min-w-0 flex-1">
      <h2 className="mb-8 text-[18px] font-bold text-[#005856]">
        KSK Policies Details
      </h2>

      <div className="overflow-hidden rounded-2xl bg-white shadow-[0_10px_30px_rgba(0,0,0,0.04)]">
        <div className="overflow-x-auto">
          <table
            className="w-full table-fixed border-collapse text-[#123764]"
            style={{ minWidth: "980px" }}
          >
            <thead>
              <tr className="bg-[#dce9fb] text-[13px] font-bold">
                {headers.map((header, index) => (
                  <th
                    key={header}
                    className={`border border-[#b8d2ff] px-2 py-5 text-center align-middle leading-[1.15] first:rounded-tl-2xl last:rounded-tr-2xl ${
                      index === 0 ? "w-[100px]" : ""
                    }`}
                  >
                    {header}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {kskProjectRows.map((row, index) => (
                <tr key={`${row.trade}-${index}`} className="bg-white">
                  <GroupedCell cell={row.state} />
                  <GroupedCell cell={row.sca} />
                  <GroupedCell cell={row.pia} />
                  <GroupedCell cell={row.sanctionedDate} />
                  <GroupedCell cell={row.sanctionedAmount} />
                  <GroupedCell cell={row.district} className="align-middle" />
                  <td className="border border-[#b8d2ff] px-2 py-3 text-center align-middle text-[13px] font-medium leading-[1.25] text-[#123764]">
                    {row.trade}
                  </td>
                  <td className="border border-[#b8d2ff] px-2 py-3 text-center align-middle text-[13px] font-medium text-[#123764]">
                    {row.candidates}
                  </td>
                  <td className="border border-[#b8d2ff] px-2 py-3 text-center align-middle text-[13px] font-medium text-[#123764]">
                    {row.duration}
                  </td>
                  <BeneficiaryCell
                    document={row.beneficiary}
                    onOpen={setSelectedDocument}
                  />
                </tr>
              ))}
              <tr className="bg-[#fbfdff] text-[13px] font-bold text-[#123764]">
                <td
                  colSpan={4}
                  className="border border-[#b8d2ff] px-2 py-3 text-center"
                >
                  Total
                </td>
                <td className="border border-[#b8d2ff] px-2 py-3 text-center">
                  95,63,880
                </td>
                <td className="border border-[#b8d2ff] px-2 py-3 text-center">
                  Rajpura
                </td>
                <td className="border border-[#b8d2ff] px-2 py-3 text-center">
                  -
                </td>
                <td className="border border-[#b8d2ff] px-2 py-3 text-center">
                  720
                </td>
                <td className="border border-[#b8d2ff] px-2 py-3 text-center">
                  -
                </td>
                <td className="border border-[#b8d2ff] px-2 py-3 text-center">
                  -
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {selectedDocument && (
        <PdfPreviewModal
          pdfDocument={selectedDocument}
          onClose={() => setSelectedDocument(null)}
        />
      )}
    </section>
  );
};

export default KskProjectDetails;
